<template>
  <main class="referral-details p-3">
    <v-breadcrumbs :options="breadcrumbs" />
    <section v-if="forwardings" class="referral-content">
      <div class="d-flex justify-content-between mb-3">
        <div class="p-2 my-auto">Ao finalizar a consulta, defina o departamento para encaminhamento do paciente.</div>        
        <div class="p-2">
          <button type="button" class="btn btn-primary" @click="saveForwarding">Salvar configuração</button>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card referral-type-card mb-3" v-for="(forwarding, index) in forwardings" :key="index">
            <div class="card-body">
              <h5 class="card-title">{{ labelStatus }} - {{ statuses[forwarding.type] }}</h5>

              <section class="mb-4">
                <h6 class="section-title">Paciente</h6>
                <div class="form-check d-flex align-items-center gap-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="patient_was_discharged"
                    v-model="forwarding.patient_was_discharged"
                  />
                  <label class="form-check-label" for="patient_was_discharged">
                    Paciente teve alta
                  </label>
                </div>
              </section>

              <section class="mb-4">
                <h6 class="section-title">Encaminhar paciente (departamentos)</h6>
                <div class="row">
                  <div class="col-12 col-md-4 mb-2">
                    <div class="form-check d-flex align-items-center gap-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`checkAllDepartments-${forwarding.type}`"
                        :checked="allDepartmentsSelected(forwarding.type)"
                        @change="toggleAllDepartments(forwarding.type, $event.target.checked)"
                      />
                      <label class="form-check-label" :for="`checkAllDepartments-${forwarding.type}`">
                        Selecionar todos os departamentos
                      </label>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-4 mb-2"
                    v-for="(department, index) in forwarding.departments"
                    :key="index"
                  >
                    <div class="form-check d-flex align-items-center gap-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'departament' + index"
                        v-model="department.active"
                      />
                      <label class="form-check-label" :for="'departament' + index">
                        {{ department.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </section>

              <section class="mb-4">
                <h6 class="section-title">Observação</h6>
                <div class="form-check d-flex align-items-center gap-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="obligation_observation"
                    v-model="forwarding.obligation_observation"
                  />
                  <label class="form-check-label" for="obligation_observation">
                    Preenchimento obrigatório da observação para encaminhamento
                  </label>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import { getCurrentClinic } from '@/utils/localStorageManager'

const tabs = {
  FINISHED: {
    label: 'Finalizar e imprimir',
    statuses: {
      FINISHED: 'Finalizar e imprimir'
    }
  },
  PAUSED: {
    label: 'Finalizar depois',
    statuses: {
      DILATING: 'Paciente dilatando',
      EXAMINATION: 'Paciente em exames',
      FINISHED_ATTENDANCE: 'Finalização pendente',
      STAND_BY_ATTENDANCE: 'Consulta em andamento'
    }
  }
};


export default {
  name: 'Referrals',
  components: {
    'v-breadcrumbs': Breadcrumbs,
  },
  props: {},
  data() {
    return {
      clinic: getCurrentClinic(),
      forwardings: null,
      breadcrumbs: [
        { label: 'Painel de chamada', onClick: this.goTo('/painel-de-chamadas/departments') },
        { label: 'Encaminhamento - Consulta', onClick: this.goTo('/painel-de-chamadas/Referrals') },
        { label: tabs[(this.$route.params.tab ?? 'finished').toUpperCase()].label }
      ],
    }
  },
  async created(){
    await this.getReferrals();
  },
  methods: {
    goTo(path) {
      return () => this.$router.push(path);
    },
    async getReferrals() {
      const loading = this.$loading.show();

      try {
        const referrals = await this.fetchReferrals();
        await this.getCallPanelDepartments();

        this.forwardings = this.buildForwardingByType(referrals);
      } catch (err) {
        this.$toast.error(err.message || 'Erro ao buscar encaminhamentos');
      } finally {
        loading.hide();
      }
    },
    async fetchReferrals() {
      const response = await this.api.getReferralsByStatus(this.clinic.id, this.paramTab);
      return response?.data?.referrals || [];
    },

    buildForwardingByType(referrals) {
      const referralByType = this.groupReferralsByType(referrals);
      const statuses = this.statuses;

      return Object.keys(statuses).reduce((acc, type) => {
        const referral = referralByType[type] ?? this.buildDefaultReferral(type);
        acc[type] = this.mapDepartmentsToReferral(referral);
        return acc;
      }, {});
    },

    groupReferralsByType(referrals) {
      return referrals.reduce((acc, referral) => {
        acc[referral.type] = referral;
        return acc;
      }, {});
    },

    buildDefaultReferral(type) {
      return {
        clinic_id: this.clinic.id,
        obligation_observation: false,
        patient_was_discharged: false,
        consultation_status: this.paramTab,
        type: type,
        referral_departments: []
      };
    },
    mapDepartmentsToReferral(referral) {
      return {
        ...referral,
        departments: this.departments.map(dep => {
          const match = referral.referral_departments?.find(rd => rd.department_id === dep.id);

          return {
            ...dep,
            id: match?.id ?? null,
            department_id: dep.id,
            active: !!match,
          };
        }),
      };
    },
    async getCallPanelDepartments() {
      const loading = this.$loading.show();
      try {
        const response = await this.api.getCallPanelDepartments(this.clinic.id);
        this.departments = response?.data || [];
      } catch (err) {
        this.$toast.error(err.message);
      } finally {
        loading.hide();
      }
    },
    async saveForwarding() {
      const loading = this.$loading.show();

      try {
        const forwardings = Object.values(this.forwardings).map(this.buildForwardingPayload);

        const response = await this.api.saveAllReferrals({
          forwardings,
          clinic_id: this.clinic.id,
        });

        response?.data?.referral && response.data.referral.forEach((saved, i) => {
          this.forwardings[saved.type].id = saved.id;
        });

        this.$toast.success('Encaminhamentos salvos com sucesso');
      } catch (err) {
        this.$toast.error(err.message || 'Erro ao salvar encaminhamentos');
      } finally {
        loading.hide();
      }
    },
    buildForwardingPayload(forwarding) {
      const selectedDepartments = forwarding.departments
        .filter(dep => dep.active)
        .map(dep => ({
          id: dep.id,
          department_id: dep.department_id,
          active: dep.active,
        }));

      return {
        ...forwarding,
        departments: selectedDepartments,
      };
    },
    toggleAllDepartments(type, active) {
      this.forwardings[type].departments.forEach(dep => {
        dep.active = active;
      });
    }
  },
  computed: {
    paramTab() {
      return this.$route.params.tab ?? 'finished';
    },
    labelStatus() { 
      return tabs[(this.$route.params.tab ?? 'finished').toUpperCase()].label;
    },
    statuses() { 
      return tabs[(this.$route.params.tab ?? 'finished').toUpperCase()].statuses;
    },
    allDepartmentsSelected() {
      return (type) => {
        return this.forwardings[type]?.departments?.every(dep => dep.active);
      };
    }
  },  
}
</script>

<style scoped lang="scss">
.referral-details {
  padding: 1rem;
  min-height: calc(100% - 74px);
}

.referral-content {
  margin-top: 1rem;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: white;
  padding: 1rem;

  .referral-type-card{
    border-radius: 8px;

    .checkbox {
      width: 16px;
      height: 16px;
      margin: auto 5px auto 0px;
    }
  }

  .card-title {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    margin-bottom: 1rem;
  }

  .section-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.15px;
    border-bottom: 1px solid #dee2e6 !important;
    margin-bottom: 0.5rem;
  }

}
</style>
